import {setLFCDataProc} from './LFCUtil';
import {queryPage, type AccumContext, type Page} from './LFCPgHistoryAccumUtil';

export type SnapshotFile = {
  device: string;
  file_path: string;
  snapshot_id: string;
  collected_at: string;
  last_seen_at: string;
  size_bytes: number;
};
export type SnapshotVersion = Omit<SnapshotFile, 'last_seen_at'> & {last_seen_at: string | null};
export type SnapshotCursor = Pick<SnapshotVersion, 'collected_at' | 'snapshot_id'>;

export const getSnapshotFiles = (
  ctx: AccumContext,
  device: string,
  after_path = ''
): Promise<Page<SnapshotFile>> => queryPage(ctx, 8024, {device, after_path});
export const getSnapshotVersions = (
  ctx: AccumContext,
  device: string,
  file_path: string,
  cursor?: SnapshotCursor
): Promise<Page<SnapshotVersion>> =>
  queryPage(ctx, 8025, {
    device,
    file_path,
    after_at: cursor?.collected_at ?? null,
    after_snapshot_id: cursor?.snapshot_id ?? null
  });

const proc = async <T>(ctx: AccumContext, parameters: object): Promise<T> => {
  const rows = await setLFCDataProc({...ctx, invoke_name: 'PgHistorySnapshot', parameters});
  if (!rows?.[0]) throw new Error('Empty snapshot response');
  return rows[0];
};
export const getSnapshotUrl = (ctx: AccumContext, device: string, snapshot_id: string) =>
  proc<{url: string; file_name: string}>(ctx, {action: 'get_snapshot_url', device, snapshot_id});
export const getSnapshotPreview = (ctx: AccumContext, device: string, snapshot_id: string) =>
  proc<{text: string; encoding: string}>(ctx, {
    action: 'get_snapshot_preview',
    device,
    snapshot_id
  });
